const Vue = require('vue')

Vue.component('form-selection-page', {
    props: {
        onlyPage: {
            type: Boolean,
            default: false
        },
        store: {
            type: Vue,
            required: true
        }
    },
    data () {
        return {
            checked: false
        }
    },
    ready () {
        this.checked = this.store.isPageSelected()

        this.store.$on('state-changed', () => {
            this.checked = this.store.isPageSelected()
        })
    },
    methods: {
        changed () {
            if (this.checked) {
                this.store.checkVisible()
            } else {
                this.store.uncheckVisible()
            }
        }
    },
    template: `
<div class="form-selection-all">
    <form-check :on-change="changed" :model.sync="checked" :disabled="!store.hasItems()"></form-check>
</div>
`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/selection-page.js